import React from 'react'
import './Error404Screen.scss';

function Error404Screen() {
  return (
    <div className='Error404Screen'>
        <div className="Error404Screen-Wrapper">
            <h1>Whoops... The Page You Are Looking For Doesn't Exist</h1>
        </div>
    </div>
  )
}

export default Error404Screen